import { _is } from './_is'

export const getPlatformImage = {
    mixins: [_is],
    methods: {
      getPlatformImage(platformId, message){
        let fileName = '';
        let mainPath = '/img/socialSvg/';


        // Facebook
        if(this.networksById[platformId].name == 'Facebook') fileName = 'facebook';
        if(message && this.networksById[platformId].name == 'Facebook' && this._is(message, 'directMessage')) fileName = 'facebookMessenger';
        if(message && this.networksById[platformId].name == 'Facebook' && this._is(message, 'ads')) fileName = 'facebookAds';

        // Instagram
        if(this.networksById[platformId].name == 'Instagram') fileName = 'instagram';
        if(message && this.networksById[platformId].name == 'Instagram' && this._is(message, 'mention')) fileName = 'instagram';
        if(message && this.networksById[platformId].name == 'Instagram' && this._is(message, 'directMessage')) fileName = 'instagramDm';
        if(message && this.networksById[platformId].name == 'Instagram' && this._is(message, 'ads')) fileName = 'instagramAds';

        // Twitter
        if(this.networksById[platformId].name == 'Twitter') fileName = 'twitter';
        if(message && this.networksById[platformId].name == 'Twitter' && this._is(message, 'directMessage')) fileName = 'twitterDm';

        // LinkedIn
        if(this.networksById[platformId].name == 'LinkedIn') fileName = 'linkedIn';

        // Shopify
        if(this.networksById[platformId].name == 'Shopify') fileName = 'shopify';

        // Youtube
        if(this.networksById[platformId].name == 'Youtube') fileName = 'youtube';

        // Email
        if(this.networksById[platformId].name == 'Email') fileName = 'email';

        // Phone
        if(this.networksById[platformId].name == 'Phone') fileName = 'phone';

        // Google Play
        if(this.networksById[platformId].name == 'Google Play') fileName = 'playStore';

        // App Store
        if(this.networksById[platformId].name == 'App Store') fileName = 'appStore';

        // Gmail
        if(this.networksById[platformId].name == 'Gmail') fileName = 'gmail';

        // GMB
        if(this.networksById[platformId].name == 'Google My Business') fileName = 'googleMyBusiness';

        // Chat
        if(this.networksById[platformId].name == 'Live Chat') fileName = 'chat';

        // Chat
        if(this.networksById[platformId].name == 'Document') fileName = 'documents2';

        // WhatsApp
        if(this.networksById[platformId].name == 'WhatsApp') fileName = 'whatsapp';

        //TrustPilot
        if(this.networksById[platformId].name == 'Trust Pilot') return mainPath + 'trustPilot.png';

        return mainPath + fileName +'.svg';
      }
    }

}


// WEBPACK FOOTER //
// ./src/components/dashboard/mixins/getPlatformImage.js